import { useMaacFeatureSettings } from "@/features/featureSettings/useMaacFeatureSettings";

export const useAccessManagementFeatureAvailable = () => {
  const { maacFeatureSettings, isMaacFeatureSettingsValid } =
    useMaacFeatureSettings();
  return isMaacFeatureSettingsValid
    ? maacFeatureSettings?.accessManagement?.level === "on"
    : false;
};
